
import { Vue, Component, Prop } from "vue-property-decorator";

interface FunctionalAssessmentData {
  mobility_status: string;
  mobility_level: string;
  mobility_notes: string;
  communication_ability: string;
  communication_notes: string;
  cognitive_concerns: string;
  cognitive_notes: string;
}

@Component
export default class FunctionalAssessment extends Vue {
  @Prop({ required: true }) readonly data!: FunctionalAssessmentData;
}
